import { error as ErrorModel } from '@/api/models'

// initial state
const state = {
  loginApiError: false
}

// getters
const getters = {
  getLoginApiError: state => state.loginApiError
}

// actions
const actions = {
  // Actions are primarily to be used for dispatching Asynchronous activities

  // Until we want to log these requests from the client-side to an external
  // service, we won't have any actions, just mutations (mutations are synchronous and immediate)
}

// TO DO - Does "Increase" mean make the bar take longer? Or does it mean increase the % fulfilled, meaning make it faster?

// mutations
const mutations = {
  setLoginApiError (state, request) {
    state.loginApiError = _.assign(_.clone(ErrorModel), request)
  },
  resetLoginApiError (state, request) {
    state.loginApiError = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/api.js